import amritsar_main from "../images/product/amritsar/amritsar_main.jpg";
import amritsar_bespoke from "../images/product/amritsar/amritsar_it_1.jpg";
import amritsar_curated from "../images/product/amritsar/amritsar_it_2.jpg";
import amritsar_outro from "../images/product/amritsar/amritsar_outro.jpg";

import kerala_main from "../images/product/kerala/kerala_main.jpg";
import kerala_bespoke from "../images/product/kerala/kerala_it_1.jpg";
import kerala_curated from "../images/product/kerala/kerala_it_2.jpg";
import kerala_outro from "../images/product/kerala/kerala_outro.jpg";

import ladakh_main from "../images/product/ladakh/ladakh_main.jpg";
import ladakh_bespoke from "../images/product/ladakh/ladakh_it_1.jpg";
import ladakh_curated from "../images/product/ladakh/ladakh_it_2.jpg";
import ladakh_outro from "../images/product/ladakh/ladakh_outro.jpg";

import kashmir_main from "../images/product/kashmir/kashmir_main.jpg";
import kashmir_bespoke from "../images/product/kashmir/kashmir_it_1.jpg";
import kashmir_curated from "../images/product/kashmir/kashmir_it_2.jpg";
import kashmir_outro from "../images/product/kashmir/kashmir_outro.jpg";

import triangle_main from "../images/product/triangle/triangle_main.jpg";
import triangle_bespoke from "../images/product/triangle/triangle_it_1.jpg";
import triangle_curated from "../images/product/triangle/triangle_it_2.jpg";
import triangle_outro from "../images/product/triangle/triangle_outro.jpg";

import bhutan_main from "../images/product/bhutan/bhutan_main.png";
import bhutan_bespoke from "../images/product/bhutan/bhutan_it_1.png";
import bhutan_curated from "../images/product/bhutan/bhutan_it_2.png";
import bhutan_outro from "../images/product/bhutan/bhutan_outro.png";

import bentota_main from "../images/product/bentota/bentota_main.png";
import bentota_bespoke from "../images/product/bentota/bentota_it_1.png";
import bentota_curated from "../images/product/bentota/bentota_it_2.png";
import bentota_outro from "../images/product/bentota/bentota_outro.png";

import nuwara_main from "../images/product/nuwara/nuwara_main.png";
import nuwara_bespoke from "../images/product/nuwara/nuwara_it_1.png";
import nuwara_curated from "../images/product/nuwara/nuwara_it_2.png";
import nuwara_outro from "../images/product/nuwara/nuwara_outro.png";

import kandy_main from "../images/product/kandy/kandy_main.png";
import kandy_bespoke from "../images/product/kandy/kandy_it_1.png";
import kandy_curated from "../images/product/kandy/kandy_it_2.png";
import kandy_outro from "../images/product/kandy/kandy_outro.png";

import amritsar_it from "../Iteneraries/india/Wanderluxe_amritsar_it.pdf";
import kashmir_it from "../Iteneraries/india/Wanderluxe_kashmir_it.pdf";
import kerala_it from "../Iteneraries/india/Wanderluxe_kerala_it.pdf";
import ladakh_it from "../Iteneraries/india/Wanderluxe_leh_ladakh_srinagar_it.pdf";
import triangle_it from "../Iteneraries/india/Wanderluxe_goldenTriangle_it.pdf";

import bhutan_it from "../Iteneraries/bhutan/Wanderluxe_bhutan_it.pdf";


import nuwara_it from "../Iteneraries/sriLanka/Wanderluxe_sriLanka_nuwara_it.pdf";
import kandy_it from "../Iteneraries/sriLanka/Wanderluxe_sriLanka_kandy_it.pdf";
import bentota_it from "../Iteneraries/sriLanka/Wanderluxe_sriLanka_bentota_it.pdf";


const IMAGES = {
  amritsar: {
    main: amritsar_main,
    it_1: amritsar_bespoke,
    it_2: amritsar_curated,
    outro: amritsar_outro,
  },
  ladakh: {
    main: ladakh_main,
    it_1: ladakh_bespoke,
    it_2: ladakh_curated,
    outro: ladakh_outro,
  },
  kashmir: {
    main: kashmir_main,
    it_1: kashmir_bespoke,
    it_2: kashmir_curated,
    outro: kashmir_outro,
  },
  kerala: {
    main: kerala_main,
    it_1: kerala_bespoke,
    it_2: kerala_curated,
    outro: kerala_outro,
  },
  triangle: {
    main: triangle_main,
    it_1: triangle_bespoke,
    it_2: triangle_curated,
    outro: triangle_outro,
  },
  bhutan: {
    main: bhutan_main,
    it_1: bhutan_bespoke,
    it_2: bhutan_curated,
    outro: bhutan_outro,
  },
  bentota: {
    main: bentota_main,
    it_1: bentota_bespoke,
    it_2: bentota_curated,
    outro: bentota_outro,
  },
  nuwara: {
    main: nuwara_main,
    it_1: nuwara_bespoke,
    it_2: nuwara_curated,
    outro: nuwara_outro,
  },
  kandy: {
    main: kandy_main,
    it_1: kandy_bespoke,
    it_2: kandy_curated,
    outro: kandy_outro,
  },
};

const data = [
  {
    country: "India",
    destinationIntro: "India Immersive",
    destinationIntroSub: "A tapestry of colors, cultures and contrast",
    details: [
      "Discover India through an experience of luxury and authentic charm. From serene wellness havens to vibrant market adventures, every moment is crafted for the discerning female traveler. A journey where elegant stays meet cultural immersion, and traditional flavors dance with modern indulgence - all tailored to your personal story.",
      "Stay in exquisite accommodations, unwind at serene wellness retreats, and delight in culinary masterpieces that blend tradition and innovation. Explore the bustling markets with personalized shopping tours, discover hidden cultural gems, and enjoy bespoke adventures tailored to your interests. Experience India in a way that harmonizes elegance, authenticity, and unforgettable moments.",
    ],
    cityList: [
      "Amritsar",
      "Jaipur",
      "Delhi",
      "Kerala",
      "Kashmir",
      "Ladakh",
      "",
    ],
    tours: [
      {
        background_color: "#97789b",
        destination: "Amritsar",
        description: "Amritsar",
        sub_description: "The Soul of Punjab",
        capital: "Chandigarh",
        bestTime: "October-March",
        info: [
          "Nestled in Punjab's heart, Amritsar is a city where spirituality, history, and culture converge. Explore the sacred Golden Temple, the holiest site in Sikhism, and witness the spiritual Palki Sahib Night Ceremony.",
          "Step back in time at Jallianwala Bagh Martyrs' Memorial and indulge in the vibrant local markets. Savor legendary Amritsari kulcha, lassis (yoghurt drink) and soak in the city's warm hospitality. Embark on a spiritual journey to Kartarpur Sahib, and discover the artistry of Phulkari embroidery."
        ],
        img_filename: "amritsar",
        itPdf: amritsar_it,
        images: IMAGES["amritsar"],
        itHighlights: [
          {
            highlight: "Golden Temple",
            description: "Explore the holiest site in Sikhism, surrounded by the serene Amrit Sarovar, and witness the Palki Sahib Night Ceremony, a deeply spiritual ritual."
          },
          {
            highlight: "Jallianwala Bagh",
            description: "Walk through this historic garden and memorial, commemorating the tragic 1919 massacre, and reflect on India’s colonial struggle."
          },
          {
            highlight: "Kartarpur Sahib",
            description: "Take a day trip to Gurdwara Darbar Sahib, one of Sikhism's most revered sites, for a spiritually enriching experience in the tranquil surroundings."
          },
        ]
      },
      {
        background_color: "#97789b",
        destination: "Delhi, Agra & Jaipur",
        sub_description: "The Golden Triangle",
        description: "Delhi, Agra, Japiur",
        capital: "New Delhi",
        bestTime: "October-March",
        info: [
          "Delhi, Agra, and Jaipur—makes a perfect introduction to India's rich history, vibrant culture, and architectural wonders. Enjoy a perfect blend of iconic sights and unforgettable memories.",
          "Experience the contrast of ancient Mughal forts and bustling markets alongside modern city life in Delhi and be mesmerized with the breathtaking Taj Mahal, a timeless symbol of love, and the grand Agra Fort in Agra.",
          "In Jaipur, known as the royal Pink City, explore majestic palaces, towering forts, and colorful bazaars.",
          "This iconic route oﬀers a glimpse into India's royal past, architectural brilliance, and diverse traditions—making it a must-see for any traveler."
        ],
        img_filename: "triangle",
        itPdf: triangle_it,
        images: IMAGES["triangle"],
        itHighlights: [
          {
            highlight: "Delhi",
            description: "A vibrant blend of old and new, from the grand Mughal-era Red Fort Qutab Minar, Humayun's Tomb and Jama Masjid to modern landmarks like India Gate and bustling bazaars."
          },
          {
            highlight: "Agra",
            description: "Home to the iconic Taj Mahal, a symbol of love and architectural brilliance, along with the majestic Agra Fort and Fatehpur Sikri."
          },
          {
            highlight: "Jaipur",
            description: "The royal Pink City, known for its stunning palaces, like Hawa Mahal and City Palace, and the imposing Amer Fort set against desert landscapes."
          },
        ]
      },
      {
        background_color: "#97789b",
        destination: "Ladakh",
        description: "Ladakh",
        sub_description: "Adventure at every altitude",
        capital: "Chandigarh",
        bestTime: "May-September",
        info: [
          "Perched in northern India, Ladakh is a land of breathtaking landscapes, ancient monasteries, and Tibetan culture.",
          "With its snow-capped peaks, crystal-clear lakes, and stark desert terrain, this Himalayan gem oﬀers breathtaking views and a sense of tranquility.",
          "Whether exploring historic monasteries, experiencing local festivals, or embarking on high-altitude adventures, Ladakh is a destination like no other."
        ],
        img_filename: "ladakh",
        itPdf: ladakh_it,
        images: IMAGES["ladakh"],
        itHighlights: [
          {
            highlight: "Pangong Lake",
            description: "A mesmerizing blue lake that changes color with the sunlight, stretching between India and Tibet."
          },
          {
            highlight: "Leh & Monasteries",
            description: "Explore Leh's bustling markets, and visit iconic monasteries like Hemis, Thiksey, and Diskit for a glimpse into Tibetan Buddhism."
          },
          {
            highlight: "Nubra Valley",
            description: "A stunning cold desert with sand dunes, Bactrian camels, and lush villages, set between rugged mountains."
          },
        ]
      },
      {
        background_color: "#97789b",
        destination: "Kashmir",
        description: "Kashmir",
        sub_description: "Valleys of Enchantment",
        capital: "Srinagar",
        bestTime: "March-November",
        info: [
          `Kashmir, in northern India, is renowned as the "Heaven on Earth" for its stunning lakes, majestic mountains, and vibrant gardens.`,
          "Discover the magic of Dal Lake's houseboats, the charm of Mughal gardens, and the thrill of skiing in Gulmarg.",
          "Whether you're exploring the lively streets of Srinagar or trekking through the scenic valleys of Pahalgam, Kashmir oﬀers unforgettable experiences in every season."
        ],
        img_filename: "kashmir",
        itPdf: kashmir_it,
        images: IMAGES["kashmir"],
        itHighlights: [
          {
            highlight: "Dal Lake & Shikara Rides",
            description: "Glide across Kashmir's famous lake on a traditional shikara, surrounded by floating markets and snow-capped peaks."
          },
          {
            highlight: "Gulmarg",
            description: "A winter wonderland with world-class skiing and Asia's highest cable car, the Gulmarg Gondola."
          },
          {
            highlight: "Pahalgam",
            description: "A scenic valley perfect for river rafting, trekking, and exploring lush meadows like Betaab Valley and Aru Valley."
          },
        ]
      },
      {
        background_color: "#97789b",
        destination: "Kerala",
        description: "Kerala",
        sub_description: "Culture, Cuisine & Coast",
        capital: "Chandigarh",
        bestTime: "October-March",
        info: [
          `Kerala, "God's Own Country," is a tropical paradise in southern India, famed for its lush greenery, serene backwaters, and pristine beaches.`,
          "From Munnar's misty hills to Thekkady's wildlife and Alleppey's houseboat cruises, its landscapes are breathtaking.",
          "Rich in culture, Kerala is known for Kathakali dance, Ayurvedic retreats, and flavourful cuisine featuring coconut and seafood.",
          "Unique traditions like snake boat races and temple festivals add to its charm."
        ],
        img_filename: "kerala",
        itPdf: kerala_it,
        images: IMAGES["kerala"],
        itHighlights: [
          {
            highlight: "Backwaters & Houseboats",
            description: "Glide through Alleppey and Kumarakom's serene waterways on a traditional houseboat, soaking in the picturesque landscapes."
          },
          {
            highlight: "Culture & Traditions",
            description: "Experience Kathakali dance, Theyyam rituals, and vibrant temple festivals, showcasing Kerala's deep-rooted heritage."
          },
          {
            highlight: "Ayurveda & Wellness",
            description: "Rejuvenate with traditional Ayurvedic treatments and yoga retreats, oﬀering holistic healing in tranquil settings."
          },
        ]
      },
    ],
  },
  {
    country: "Bhutan",
    destinationIntro: "Bhutan Enchantment",
    destinationIntroSub:
      "A collection of curated journeys that invite you to experience the enchanting beauty and rich culture of the Land of the Thunder Dragon. Explore the serene landscapes and vibrant towns of Bhutan with our handpicked tours and experiences.",
    details: [
      "Journey into the heart of Bhutan, where culture, nature, and tranquility intertwine. Wake up to breathtaking mountain views, rejuvenate with ancient wellness rituals, and savor the rich flavors of Bhutanese cuisine. Wander through sacred monasteries, vibrant markets, and hidden villages, uncovering stories woven through time. Whether you seek adventure or reflection, every moment is designed to inspire and connect you to Bhutan's soulful beauty.",
    ],
    tours: [
      {
        carousel: {
          subDest: "Punakha",
          content:
            '<div class="experiences"><div class="experiences-heading"><h1><Kashmir\'s Blissful Symphony</h1></div></div>',
        },
        background_color: "#d493a1",
        destination: "Bhutan",
        images: IMAGES["bhutan"],
        description: "Bhutan",
        sub_description: "Beauty Meets Culture",
        info: [
          'Nestled in the Eastern Himalayas, Bhutan is a land of pristine nature, ancient monasteries, and deep - rooted traditions; also known as the "Kingdom of Happiness."',
          "Marvel at majestic dzongs, hike to the iconic Tiger's Nest Monastery, and soak in stunning views from Dochula Pass. Explore Thimphu's cultural gems, Bhutan's unique wildlife, and experience the serenity of Punakha Dzong.",
          "For adventure seekers, Bhutan oﬀers scenic treks, vibrant festivals, and rich cultural experiences—a journey unlike any other."
        ],
        itHighlights: [
          {
            highlight: "Tiger's Nest Monastery",
            description: "A breathtaking cliﬀside temple and Bhutan's most iconic site. Punakha Dzong & Tashichho"
          },
          {
            highlight: "Dzong",
            description: "Stunning fortresses showcasing Bhutanese architecture and history."
          },
          {
            highlight: "Buddha Dordenma",
            description: "A massive golden Buddha overlooking the capital, Thimphu."
          },
        ],
        special: [],
        img_filename: "bhutan",
        pax_bespoke: "1-2 pax upwards",
        pax_curated: "10-15 pax upwards",
        itPdf: bhutan_it,
        bestTime: "March-May",
        bestTime_fest: "September-Novemeber",
        currency: "Bhutanese ngultrum (BTN), Indian Rupee (INR)",
        currencyNum: 2,
        languages: "Dzongkha",
        tz: "UTC+06:00",
        outro: "A Passage to Serenity and Ancient Traditions",
        attractions: "Coming Soon",
      },

    ],
  },
  {
    carousel: {
      subDest: "Ladakh",
      content:
        '<div class="experiences"><div class="experiences-heading"><h1>Kashmir\'s Blissful Symphony</h1></div></div>',
    },
    country: "SriLanka",
    destinationIntro: "Sri Lanka Escapes",
    destinationIntroSub:
      "A collection of curated journeys that unveil the captivating beauty and cultural richness of this tropical paradise. Explore the diverse landscapes, vibrant cities, and pristine shores of Sri Lanka with our handpicked tours and experiences.",
    details: [
      "Sri Lanka captivates with its rich culture, breathtaking landscapes, and indulgent experiences. Stay in elegant retreats, rejuvenate with world-class spa rituals, and savor exquisite cuisine infused with bold spices. Visit ancient temples, wander through lush tea plantations, and soak in the energy of bustling markets. From thrilling safaris to serene coastal escapes, every moment is thoughtfully designed for both adventure and relaxation.",
      "From luxurious hotels, world-class spa treatments, to savouring exquisite cuisine blending local flavors with international finesse. Discover the rich history of ancient temples, explore lush tea plantations, and stroll through bustling markets. Engage in bespoke adventures, from wildlife safaris in national parks to serene boat rides on tranquil lagoons. Experience Sri Lanka's perfect blend of natural splendor, cultural depth, and refined luxury.",
    ],
    tours: [
      {
        background_color: "#97789b",
        destination: "Kandy",
        sub_description: "Sri Lanka's Sacred Sites",
        description: "Mihinthale, Polonnaruwa, Kandy",
        link: "https://www.something.com",
        images: IMAGES["kandy"],
        itPdf: kandy_it,
        img_filename: "kandy",
        bestTime: "April-September",
        currency: "INR",
        info: [
          `Step into Sri Lanka's spiritual heart with visits to ancient cities and sacred temples.`,
          `From the iconic Sigiriya Rock Fortress and the Dambulla Cave Temple to the timeless relics of Anuradhapura and Kandy's revered Temple of the Tooth Relic, this journey unveils the island's profound cultural legacy.`,
          `Discover heritage landmarks, lush gardens, and serene monasteries as you traverse this enchanting land`
        ],
        itHighlights: [
          {
            highlight: "Temple of the Tooth Relic (Kandy)",
            description: "Visit the sacred temple, home to a revered relic of Buddha."
          },
          {
            highlight: "Ancient City of Anuradhapura",
            description: "Explore centuries-old stupas, monasteries, and the sacred Bo Tree."
          },
          {
            highlight: "Dambulla Cave Temple",
            description: "Marvel at intricate cave paintings and impressive statues of Buddha."
          },
        ],
        special: [],
        pax_bespoke: "1-2 pax upwards",
        pax_curated: "10-15 pax upwards",
        bestTime_bespoke: "Year round",
        bestTime_curated: "October-March",
        tz: "UTC+5:30",
        outro: "Unwind In Lush Green Vistas and Refreshing Mountain Air",
        attractions: "Coming Soon",
      },
      {
        background_color: "#d1bdaf",
        destination: "Bentota",
        sub_description: "Timeless Treasures & Serene Landscapes",
        description: "Yala, Sirigiya & Bentota",
        images: IMAGES["bentota"],
        pax_bespoke: "1-2 pax upwards",
        pax_curated: "10-15 pax upwards",
        bestTime_bespoke: "Year round",
        bestTime_curated: "October-March",
        link: "https://www.something.com",
        currency: "INR",
        itPdf: bentota_it,
        info: [
          `Discover the breathtaking diversity of Sri Lanka, from the majestic rock fortress of Sigiriya to the cultural charm of Kandy.`,
          `Journey through the misty tea plantations of Nuwara Eliya, encounter wildlife at Yala National Park, and unwind on the golden beaches of Bentota.`,
          `This 7-day adventure seamlessly blends heritage, natural beauty, and unforgettable experiences.`
        ],
        itHighlights: [
          {
            highlight: "Sigiriya Rock Fortress",
            description: "Climb the ancient rock citadel adorned with stunning frescoes and panoramic views."
          },
          {
            highlight: "Nuwara Eliya Tea Plantations",
            description: "Wander through lush tea estates and visit a local tea factory for a taste of Ceylon's finest."
          },
          {
            highlight: "Yala National Park",
            description: "Embark on an exhilarating safari to spot leopards, elephants, and an array of wildlife"
          },
        ],
        special: [],
        languages: "Ladakhi, Tibetan and Urdu",
        tz: "UTC+5:30",
        img_filename: "bentota",
        outro: "Tranquil Shores and Thrilling Coastal Adventures",
        attractions: "Coming Soon",
      },
      {
        carousel: {
          subDest: "Ladakh",
          content:
            '<div class="experiences"><div class="experiences-heading"><h1>Kashmir\'s Blissful Symphony</h1></div></div>',
        },
        background_color: "#b3c8d3",
        destination: "nuwara",
        sub_description: "Highlands, Safaris, & Scenic Wonders",
        description: "Minneriya, Nurawa Eliya & Waikkal",
        link: "https://www.something.com",
        images: IMAGES["nuwara"],
        itPdf: nuwara_it,
        img_filename: "nuwara",
        bestTime: "April-September",
        info: [
          `Embrace Sri Lanka's wild spirit on this 6-day journey. Venture into the lush jungles of Habarana, spot elephants at Minneriya Safari, and explore the cool highlands of Nuwara Eliya.`,
          `End your adventure with a tranquil retreat at Waikkal, where nature and serenity await. A perfect blend of wilderness and scenic beauty.`,
        ],
        itHighlights: [
          {
            highlight: "Minneriya Safari",
            description: "Witness the awe-inspiring gathering of wild elephants in their natural habitat."
          },
          {
            highlight: "Nuwara Eliya's Colonial Charm",
            description: "Stroll through picturesque gardens and quaint English-style cottages."
          },
          {
            highlight: "Waikkal's Coastal Serenity",
            description: "Relax at a scenic beachside retreat, surrounded by mangroves and lagoon views."
          },
        ],
        pax_bespoke: "1-2 pax upwards",
        pax_curated: "10-15 pax upwards",
        pax_special: "4-6 pax upwards",
        bestTime_bespoke: "Year Round",
        bestTime_curated: "October-March",
        bestTime_special: "Seasonal",
        currency: "INR",
        languages: "Ladakhi, Tibetan and Urdu",
        outro: "Experience The Blend of Tradition and Modernity",
        tz: "UTC+5:30",
        attractions: "Coming Soon",
      },
    ],
  },
];

export default data;
